import { useCurrentProject } from "@radarly/core/project/use-cases";

export function useCustomFields() {
  return useCurrentProject()?.tags?.custom;
}
